import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const SpecialClause = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Special Clause</Text>
      <View style={styles.list}>
        <Text style={styles.listItem}>
          Buyer and Seller acknowledge receipt of a copy of this Agreement at
          the time of signing.
        </Text>
        <Text style={styles.listItem}>
          This Agreement may be executed in one or more counterparts, each of
          which shall be deemed to be an original and which counterparts
          together shall constitute one and the same Agreement of the Parties.
        </Text>
      </View>
    </View>
  );
};

export default SpecialClause;
